// extracted by mini-css-extract-plugin
export default {"row":"ClientDetailsData_row__fK-Yb","label":"ClientDetailsData_label__rwiIw","flex":"ClientDetailsData_flex__0BKpO","addressTitle":"ClientDetailsData_addressTitle__O2Pmq"};